// extracted by mini-css-extract-plugin
export default {"cannoli-page":"styles_cannoli-page__aX8y1"};